import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "promocode-processing"
};
var _hoisted_2 = {
  class: "d-flex flex-column fl-a-c fl-j-c"
};
var _hoisted_3 = {
  class: "processing-order"
};
var _hoisted_4 = {
  class: "mb-20",
  style: {
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.modalVisible = $event;
    }),
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "show-close": false
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("promocode.processing-order")), 1), _createVNode(_component_el_button, {
        class: "spinner",
        loading: true
      }), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.message), 1)])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}